import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';
import { convertToHttpParams } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { BillingAddressesWithAccountingEmail } from './model/billing-addresses-with-accounting-email';

@Injectable({
  providedIn: 'root'
})
export class BillingInformationService {
  constructor(private http: HttpClient) {}

  fetchBillingAddresses(contractId: string | null): Observable<BillingAddressesWithAccountingEmail> {
    return this.http.get<BillingAddressesWithAccountingEmail>(PLATFORM_ENVIRONMENT.apiUrl + '/billingInformation', {
      params: convertToHttpParams({ contractId })
    });
  }
}
